module.exports = __webpack_public_path__ + "static/media/dsp_background_tp.e73b66ee.png";